import { checkoutUserErrorFragment } from './fragmentGeneral.gql';
import checkoutFragment from './fragmentCheckout.gql';

const checkoutLineItemsUpdate = ({ country }) => (
	`mutation ($checkoutId: ID!, $lineItems: [CheckoutLineItemUpdateInput!]!) @inContext(country: ${country}) {
		checkoutLineItemsUpdate(checkoutId: $checkoutId, lineItems: $lineItems) {
			checkoutUserErrors ${checkoutUserErrorFragment}
			checkout ${checkoutFragment}
		}
	}`
);

export default checkoutLineItemsUpdate;
